export function addCurrent(category) {
    return {
        type: 'ADD_CURRENT',
        category,
    }
}

